import "./App.css";

function App() {
  return (
    <>
      <section className="head">
        <div className="hh1">
          <p>Xenotix Tech</p>
        </div>
        <div className="hh2">
          <p>Got a startup Idea !</p>
        </div>
        <div className="hh3">
          <p>Let's Turn It Into Reality.</p>
        </div>
      </section>

      <img src="Vector.png" className="vector" alt="Vector" />
      <img src="Vector (1).png" className="vector1" alt="Vector 1" />
      <img src="Vector (2).png" className="vector2" alt="Vector 2" />
      <img src="Vector (3).png" className="vector3" alt="Vector 3" />

      <div className="sec"></div>

      <section>
        <img src="Frame 20.png" className="img1" alt="Frame 20" />
        <img src="Frame 21.png" className="img2" alt="Frame 21" />
        <img src="Frame 22.png" className="img3" alt="Frame 22" />
        <img src="Frame 19.png" className="img4" alt="Frame 19" />
        <img src="Frame 20 (1).png" className="img5" alt="Frame 20 (1)" />
        <img src="Frame 20 (2).png" className="img6" alt="Frame 20 (2)" />
      </section>

      <section>
        <img src="Group 158.png" className="sec2img1" alt="Group 158" />
        <img src="Group 157.png" className="sec2img2" alt="Group 157" />
        <img src="Frame 29.png" className="sec2img3" alt="Frame 29" />
        <img src="Frame 28.png" className="sec2img4" alt="Frame 28" />
        <img src="Frame 13.png" className="Frame13" alt="Frame 13" />
      </section>

      <section className="siderec">
        <p className="siderec-txt">Artificial Intelligence</p>
        <p className="siderec-txt1">Startup Growth</p>
        <div className="rec"></div>
        <div className="rec1">
          <p>Mobile</p>
        </div>
        <div className="rec2">
          <p>Web-Application</p>
        </div>
      </section>

      <img src="Vector 32.png" className="v32" alt="Vector 32" />

      <section>
        <img src="Frame 43.png" className="div-img1" alt="Frame 43" />
        <img src="Frame 43 (1).png" className="div-img2" alt="Frame 43 (1)" />
        <img src="Frame 15.png" className="div-img3" alt="Frame 15" />
        <img src="Frame 40.png" className="div-img4" alt="Frame 40" />
        <img src="Frame 31.png" className="div-img5" alt="Frame 31" />
        <img src="Frame 30.png" className="div-img6" alt="Frame 30" />
      </section>

      <section className="rectangle">
        <p>Curious About IoT..?</p>
        <span className="rect-txt">Why Not Create It?</span>
        <img src="Frame 47.png" className="Frame47" alt="Frame 47" />
        <img src="Frame 63.png" className="Frame63" alt="Frame 63" />
        <img src="Frame 60.png" className="Frame60" alt="Frame 60" />
        <img src="Frame 65.png" className="Frame65" alt="Frame 65" />
        <img src="Frame 66.png" className="Frame66" alt="Frame 66" />
        <img src="Frame 62.png" className="Frame62" alt="Frame 62" />
        <img src="Frame 64.png" className="Frame64" alt="Frame 64" />
        <img src="Frame 61.png" className="Frame61" alt="Frame 61" />
        <img src="image 10.png" className="image10" alt="Frame" />
        <img src="image 10.png" className="image11" alt="Frame" />
        <img src="image 10.png" className="image12" alt="Frame" />
        <img src="image 9.png" className="image9" alt="Frame" />

        <div className="divcon">
          <img src="Vector 35.png" alt="Outer" className="dim1" />
          <img src="Vector (4).png" alt="Inner" className="dim2" />
        </div>

        <div className="ellipse67">
          <img src="Vector (5).png" className="v5" alt="Vector 5" />
        </div>

        <div className="divmat">
          <img src="mat.png" className="mat" alt="mat" />
        </div>

        <div className="div6">
          <img src="smile.png" className="v6" alt="smile" />
        </div>

        <div className="div7">
          <img src="Vector (7).png" className="v7" alt="Vector 7" />
        </div>

        <div className="div8">
          <img src="mdi_firewire.png" className="v8" alt="firewire" />
        </div>

        <img src="Vector (6).png" className="v9" alt="Vector 6" />
        <img src="Vector (8).png" className="v10" alt="Vector 8" />
        <img src="Vector (9).png" className="v11" alt="Vector 9" />
        <img src="Rectangle 94.png" className="rec94" alt="Rectangle 94" />
        <img src="Rectangle 93.png" className="rec93" alt="Rectangle 93" />
        <img src="Vector 34.png" className="v12" alt="Vector 34" />
        <img src="Vector 33.png" className="v13" alt="Vector 33" />
      </section>
    </>
  );
}

export default App;
